module.exports = __webpack_public_path__ + "media/ecom/addons-d7b07443.svg";